import React, { useEffect, useState } from 'react';
import { AccordionBodyItem, AccordionHeaderTitle } from 'component/Accordion';
import { InputComponent } from 'component/Input';
import { RadioButton } from 'component/RadioButton';
import {
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  Accordion,
  AccordionItem,
} from 'react-accessible-accordion';
import { toast } from 'react-toastify';
import { SelectComponent } from 'component/Select';
import { AccordionBodyItem2 } from '../../../component/Accordion';
import axios from 'axios';
import { AsyncSelectComponent } from '../../../component/Select';

export const NTOResult = (props) => {
  const handleNTOReason = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          nto_reason: value,
          from_existing_ha_report: value === 'repeated' ? prevFormData.info.nto_result.from_existing_ha_report : false,
          hazard_area_id: value === 'repeated' ? prevFormData.info.nto_result.hazard_area_id : null,
          is_update_required: value === 'repeated' ? prevFormData.info.nto_result.is_update_required : false,
        },
      },
    }));
  };
  const handleNTOEvidences = (value) => {
    const isEvidencesTrue = value === 'true';
    props.setFormData((prevFormData) => {
      return {
        ...prevFormData,
        info: {
          ...prevFormData.info,
          nto_result: {
            ...prevFormData.info.nto_result,
            evidences: isEvidencesTrue,
            is_already_in_progress: isEvidencesTrue ? null : false,
          },
        },
      };
    });
  };

  const loadHaReportOptions = async (inputValue) => {
    try {
      const response = await axios.get('/reports/ha/', {
        params: {
          by_hierarchy: true,
          pagination: false,
          imsma_id: inputValue,
        },
      });
      return response?.data?.map((report) => ({
        value: report?.info?.general?.imsma_id,
        label: report?.info?.general?.imsma_id,
      }));
    } catch (error) {
      console.error('Error fetching HA reports:', error);
      return [];
    }
  };

  const notifyHazardCancellation = () => {
    toast.error(
      "Не забудьте створити звіт про відміну небезпечної ділянки / Do not forget to create a report on the cancellation of the hazardous area",
      { autoClose: false }
    );
  };

  const handleNTOVillageByVillage = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          village_by_village: value === 'true' ? true : false,
        },
      },
    }));
  };

  const handleNTOAmmoReport = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          single_ammo_report_needed: value === 'true' ? true : false,
        },
      },
    }));
  };

  const handleNTONewHazard = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          new_hazard_area_report_needed: value === 'true' ? true : false,
        },
      },
    }));
  };

  const handleNTOComment = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          comment: value,
        },
      },
    }));
  };

  const handleIsAlreadyInProgress = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          is_already_in_progress: value === 'true' ? true : false,
        },
      },
    }));
  };

  const handleFromExistingHaReport = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData?.info,
        nto_result: {
          ...prevFormData?.info?.nto_result,
          from_existing_ha_report: value === 'true',
          hazard_area_id: value === 'true' ? prevFormData.info?.nto_result?.hazard_area_id : null,
          is_update_required: value === 'true' ? prevFormData.info?.nto_result?.is_update_required : false,
          ha_imsma_id: value === 'true' ? prevFormData.info?.nto_result?.ha_imsma_id : null,
        },
      },
    }));
  };

  const handleIsUpdateRequired = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        nto_result: {
          ...prevFormData.info.nto_result,
          is_update_required: value === 'true',
        },
      },
    }));
  };

  return (
    <>
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId="3"
            titleUA="Результат НТО"
            titleEN="Result of NTO"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <AccordionBodyItem
          accordionSubId="3.0"
          titleUA="Village by village"
          titleEN="Village by village"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
              <RadioButton
                label="Так / Yes"
                checked={props.formData.info.nto_result.village_by_village === true}
                id="village_by_village_yes"
                value
                name="village_by_village"
                disabled={false}
                handleInput={handleNTOVillageByVillage}
              />
              <RadioButton
                label="Ні / No"
                checked={props.formData.info.nto_result.village_by_village === false}
                id="village_by_village_no"
                value={false}
                name="village_by_village"
                disabled={false}
                handleInput={handleNTOVillageByVillage}
              />
            </div>
          )}
        />
        <AccordionBodyItem
          accordionSubId="3.1"
          titleUA="Причини проведення HTO"
          titleEN="Reasons for performing NTS"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
              <RadioButton
                label={(
                  <>
                    <div>Заплановане НТО /</div>
                    <div>Planned NTO</div>
                  </>
                )}
                checked={props.formData.info.nto_result.nto_reason === 'planned'}
                id="nto_reason_planned"
                value="planned"
                name="nto_reason"
                disabled={false}
                handleInput={handleNTOReason}
              />
              <RadioButton
                label={(
                  <>
                    <div>По заявці інше /</div>
                    <div>Application other</div>
                  </>
                )}
                checked={props.formData.info.nto_result.nto_reason === 'application'}
                id="nto_reason_application"
                value="application"
                name="nto_reason"
                disabled={false}
                handleInput={handleNTOReason}
              />
              <RadioButton
                label={(
                  <>
                    <div>По заявці від фермерів (Feodal) /</div>
                    <div>Application from farmers (Feodal)</div>
                  </>
                )}
                checked={props.formData.info.nto_result.nto_reason === 'farmer'}
                id="nto_reason_farmer"
                value="farmer"
                name="nto_reason"
                disabled={false}
                handleInput={handleNTOReason}
              />
              <RadioButton
                label={(
                  <>
                    <div>Повторне НТО /</div>
                    <div>Repeated NTO</div>
                  </>
                )}
                checked={props.formData.info.nto_result.nto_reason === 'repeated'}
                id="nto_reason_repeated"
                value="repeated"
                name="nto_reason"
                disabled={false}
                handleInput={handleNTOReason}
              />
            </div>
          )}
        />
      {props?.formData?.info?.nto_result?.nto_reason === 'repeated' &&
        <>
    <AccordionBodyItem
  accordionSubId="3.1.1"
  titleUA="Чи це НТО виконується на існуючій небезпечній ділянці?"
  titleEN="Is this NTO performed on an existing hazard area?"
  rightContentClassName="w-40"
  children={(
    <div className="grid-columns-2">
      <RadioButton
        label="Так / Yes"
        checked={props?.formData?.info?.nto_result?.from_existing_ha_report}
        id="from_existing_ha_report_yes"
        value={true}
        name="from_existing_ha_report"
        disabled={false}
        handleInput={handleFromExistingHaReport}
      />
      <RadioButton
        label="Ні / No"
        checked={!props?.formData?.info?.nto_result?.from_existing_ha_report}
        id="from_existing_ha_report_no"
        value={false}
        name="from_existing_ha_report"
        disabled={false}
        handleInput={handleFromExistingHaReport}
      />
    </div>
  )}
/>
    {props?.formData?.info?.nto_result?.from_existing_ha_report && (
    <>
    <div style={{width:'64vw'}}>
          <AccordionBodyItem
            accordionSubId="3.1.2"
            titleUA="Оберіть ID небезпечної ділянки I3T / 3T"
            titleEN="Select the ID of the hazard area I3T / 3T"
          >
            <AsyncSelectComponent
              promiseOptions={loadHaReportOptions}
              value={
                props?.formData?.info?.nto_result?.ha_imsma_id
                  ? {
                      value: props.formData.info.nto_result.ha_imsma_id,
                      label: props.formData.info.nto_result.ha_imsma_id,
                    }
                  : null
              }
              handleSelect={(selectedValue) => {
                props.setFormData((prevFormData) => ({
                  ...prevFormData,
                  info: {
                    ...prevFormData.info,
                    nto_result: {
                      ...prevFormData.info.nto_result,
                      ha_imsma_id: selectedValue,
                    },
                  },
                }));
              }}
              placeholder="Select ID I3T / 3T"
            />
          </AccordionBodyItem>
            </div>
     <div style={{width:'64vw'}}>
    <AccordionBodyItem
          accordionSubId="3.1.3"
          titleUA="Широта та довгота небезпечної ділянки"
          titleEN="Latitude and longitude of the hazard area"

        >
          <div className="flex-group">
          <span style={{ marginRight: '100px' , fontWeight: '600' ,width: '100px'}}>
            Long:
            <span style={{marginLeft:'4px',fontWeight:'500'}} >
            {props?.coords3857[0] ? props?.coords3857[0]?.toFixed(0) : 0}
            </span>
          </span>
          <span style={{ fontWeight: '600', width: '100px' }}>
            Lat:
            <span style={{marginLeft:'4px',fontWeight:'500'}} >
            {props?.coords3857[1] ? props?.coords3857[1]?.toFixed(0) : 0}
            </span>
          </span>
      </div>
        </AccordionBodyItem>
</div>
          <AccordionBodyItem
          accordionSubId="3.1.4"
          titleUA="Чи потребує оновлення існуючий І3Т / 3Т?"
          titleEN="Does the existing I3T / 3T need to be updated?"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
            <RadioButton
              label="Так / Yes"
              checked={props?.formData?.info?.nto_result?.is_update_required}
              id="is_update_required_yes"
              value={true}
              name="is_update_required"
              disabled={false}
              handleInput={handleIsUpdateRequired}
            />
            <RadioButton
              label="Ні / No"
              checked={!props?.formData?.info?.nto_result?.is_update_required}
              id="is_update_required_no"
              value={false}
              name="is_update_required"
              disabled={false}
              handleInput={handleIsUpdateRequired}
            />
          </div>
          )}
        />
      {props?.formData?.info?.nto_result?.is_update_required === true && (
        <div style={{width:'69vw'}}>
          <AccordionBodyItem2
            titleUA="Зверніться до ЦПМД для внесення змін до ІЗТ / 3Т"
            titleEN="Contact the CPMD to make changes to the I3T / 3T"
            />
            </div>
      )}
          </>
      )}
        </>}
        <AccordionBodyItem
          accordionSubId="3.2"
          titleUA="Чи виявлені будь-які докази?"
          titleEN="Have any evidence been found?"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
              <RadioButton
                label="Так / Yes"
                checked={props?.formData?.info?.nto_result?.evidences === true}
                id="evidences_yes"
                value
                name="evidences"
                disabled={false}
                handleInput={handleNTOEvidences}
              />
              <RadioButton
                label="Ні / No"
                checked={props?.formData?.info?.nto_result?.evidences === false}
                id="evidences_no"
                value={false}
                name="evidences"
                disabled={false}
                handleInput={handleNTOEvidences}
              />
            </div>
          )}
        />
        {props?.formData?.info?.nto_result?.evidences === false && (
          <AccordionBodyItem
            accordionSubId="3.2.1"
            titleUA="Чи це НТО виконується на існуючій небезпечній ділянці і вона потребує відміни?"
            titleEN="Is this non-routine operation being performed in an existing hazardous area, and does it require cancellation?"
            rightContentClassName="w-40"
            children={(
              <div className="grid-columns-2">
                <RadioButton
                  label="Так / Yes"
                  checked={props?.formData?.info?.nto_result?.is_already_in_progress === true}
                  id="is_already_in_progress_yes"
                  value
                  name="is_already_in_progress"
                  disabled={false}
                  handleInput={(value) => {
                    handleIsAlreadyInProgress(value);
                    if (value) notifyHazardCancellation();
                  }}
                />
                <RadioButton
                  label="Ні / No"
                  checked={props?.formData?.info?.nto_result?.is_already_in_progress === false}
                  id="is_already_in_progress_no"
                  value={false}
                  name="is_already_in_progress"
                  disabled={false}
                  handleInput={handleIsAlreadyInProgress} />
              </div>
            )}
          />
        )}
        <AccordionBodyItem
          accordionSubId="3.3"
          titleUA="Чи має бути створено звіт про виявлення одиничного боєприпасу?"
          titleEN="Should a report be created for the detection of a single ordnance?"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
              <RadioButton
                label="Так / Yes"
                checked={props.formData.info.nto_result.single_ammo_report_needed === true}
                id="ammo_report_yes"
                value
                name="single_ammo_report_needed"
                disabled={false}
                handleInput={handleNTOAmmoReport}
              />
              <RadioButton
                label="Ні / No"
                checked={props.formData.info.nto_result.single_ammo_report_needed === false}
                id="ammo_report_no"
                value={false}
                name="single_ammo_report_needed"
                disabled={false}
                handleInput={handleNTOAmmoReport}
              />
            </div>
          )}
        />
        <AccordionBodyItem
          accordionSubId="3.4"
          titleUA="Чи має бути створено нову небезпечну територію?"
          titleEN="Should a new hazardous area be established?"
          rightContentClassName="w-40"
          children={(
            <div className="grid-columns-2">
              <RadioButton
                label="Так / Yes"
                checked={props.formData.info.nto_result.new_hazard_area_report_needed === true}
                id="new_hazard_yes"
                value
                name="new_hazard_area_report_needed"
                disabled={false}
                handleInput={handleNTONewHazard}
              />
              <RadioButton
                label="Ні / No"
                checked={props.formData.info.nto_result.new_hazard_area_report_needed === false}
                id="new_hazard_no"
                value={false}
                name="new_hazard_area_report_needed"
                disabled={false}
                handleInput={handleNTONewHazard}
              />
            </div>
          )}
        />
        <AccordionBodyItem
          accordionSubId="3.5"
          titleUA="Коментар"
          titleEN="Comment"
        />
        <InputComponent
          classNameWrapper="w-100"
          style={{ width: '-webkit-fill-available' }}
          value={props.formData.info.nto_result.comment}
          handleInput={handleNTOComment}
          id="nto-comment"
          name="nto-comment"
        />
      </AccordionItemPanel>
    </>
  );
};
